import FileUploadIcon from '@mui/icons-material/FileUpload'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { Box, Button, IconButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IUploadFileProps {
  onSubmit: (file: File) => void
  isDelete?: boolean
  fileName?: string
}
const Input = styled('input')({
  position: 'absolute',
  background: 'red',
  height: '120px',
  width: '350px',
  bottom: 0,
  opacity: 0,
})
export const UploadFile: React.FC<IUploadFileProps> = ({
  onSubmit,
  isDelete,
  fileName,
}): JSX.Element => {
  const { t } = useTranslation()
  const [file, setFile] = useState<File | null>()
  useEffect(() => {
    if (isDelete) {
      setFile(null)
    }
  }, [isDelete])

  const onChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    await onSubmit(e.target.files[0])
    setFile(e.target.files[0])
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '352px',
        background: '#FFFFFF',
        border: '3px dashed #EEEEEE',
        borderRadius: '4px',
        textAlign: 'center',
        padding: '16px',
      }}
    >
      <IconButton
        onClick={() => onSubmit}
        aria-label="upload picture"
        sx={{ width: '70px', height: '70px' }}
      >
        <UploadFileIcon sx={{ width: '50px', height: '50px' }} />
      </IconButton>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        {!file && !fileName?.length && (
          <Input
            type="file"
            name={'file'}
            width="100%"
            height={'100%'}
            sx={{
              position: 'absolute',
            }}
            onChange={onChange}
          />
        )}
        <Typography
          variant={'body1'}
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.15px',
            color: '#000000',
          }}
        >
          {t('proforma_invoice.drop_your_files_here_or')}&nbsp;
        </Typography>
        <Button
          disabled={!!file || !!fileName}
          size={'small'}
          variant="outlined"
          startIcon={<FileUploadIcon />}
        >
          {t('proforma_invoice.upload')}
          {!file && (
            <Input
              onChange={onChange}
              type="file"
              width="100%"
              height={'100%'}
              sx={{
                position: 'absolute',
              }}
            />
          )}
        </Button>
      </Box>
    </Box>
  )
}
